const OG_IMAGE = "https://aisectintercollege.in/assets/og/aisect_inter_college_bn_1.png";

const seoRoutes = {
  "/": {
    title: "AISECT Inter College",
    description:
      "AISECT Inter College – admissions, courses, syllabus, notices, circulars and academic resources.",
    image: OG_IMAGE,
  },

  "/event": {
    title: "Events | AISECT Inter College",
    description:
      "Explore upcoming and past events at AISECT Inter College. Stay updated with campus activities.",
    image: OG_IMAGE,
  },

  "/contact": {
    title: "Contact | AISECT Inter College",
    description:
      "Contact AISECT Inter College for admissions, course details, and academic support. We’re here to help.",
    image: OG_IMAGE,
  },

  "/about": {
    title: "About | AISECT Inter College",
    description:
      "Know more about AISECT Inter College: our history, academics, infrastructure, and student support.",
    image: OG_IMAGE,
  },

  "/admission": {
    title: "Admission | AISECT Inter College",
    description:
      "Apply for admission at AISECT Inter College. View eligibility, documents required, and admission process.",
    image: OG_IMAGE,
  },

  "/feestructure": {
    title: "Fee Structure | AISECT Inter College",
    description:
      "View the latest fee structure for AISECT Inter College. Transparent and updated fee details.",
    image: OG_IMAGE,
  },

  "/notice": {
    title: "Notices | AISECT Inter College",
    description:
      "Latest notices and updates from AISECT Inter College. Important announcements for students and parents.",
    image: OG_IMAGE,
  },

  "/event-details": {
    title: "Event Details | AISECT Inter College",
    description:
      "Details of events at AISECT Inter College including schedules, venue, and highlights.",
    image: OG_IMAGE,
  },

  "/circular": {
    title: "Circulars | AISECT Inter College",
    description:
      "Official circulars issued by AISECT Inter College. Stay informed with the latest circular updates.",
    image: OG_IMAGE,
  },

  "/principalmessage": {
    title: "Principal’s Message | AISECT Inter College",
    description:
      "Read the Principal’s message and vision for academic excellence at AISECT Inter College.",
    image: OG_IMAGE,
  },

  "/aboutcollege": {
    title: "About College | AISECT Inter College",
    description:
      "Learn about the campus, departments, academics, and facilities at AISECT Inter College.",
    image: OG_IMAGE,
  },

  "/mission": {
    title: "Mission | AISECT Inter College",
    description:
      "Our mission: quality education, strong values, and career-ready learning at AISECT Inter College.",
    image: OG_IMAGE,
  },

  "/vision": {
    title: "Vision | AISECT Inter College",
    description:
      "Our vision: empower students with knowledge, skills, and character at AISECT Inter College.",
    image: OG_IMAGE,
  },

  "/missionvision": {
    title: "Mission & Vision | AISECT Inter College",
    description:
      "Explore the mission and vision of AISECT Inter College and our commitment to student success.",
    image: OG_IMAGE,
  },

  "/syllabus": {
    title: "Syllabus | AISECT Inter College",
    description:
      "Download class 11 and 12 syllabus for all subjects at AISECT Inter College.",
    image: OG_IMAGE,
  },

  "/courses": {
    title: "Courses | AISECT Inter College",
    description:
      "Browse all courses offered by AISECT Inter College with details, eligibility and syllabus information.",
    image: OG_IMAGE,
  },
};

export default seoRoutes;
